var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('category-page',{attrs:{"category-list":_vm.categoryList,"route-name":"config-home","title":"Configuration","icon":"mdi-hammer-wrench"}})}
var staticRenderFns = []

export { render, staticRenderFns }